export default __webpack_public_path__ + "static/media/tinkercad-login.b4555882.png";